import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hundredDelimeter'
})
export class HundredDelimeterPipe implements PipeTransform {

  transform(value: number | string, locale?: string): string {
    return new Intl.NumberFormat('en-US').format(Number(value));
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/hundredDelimeter.pipe.ts